import { gql } from "graphql-request";
import * as z from "zod";

export const MigrationDataSchema = z.object({
  migrationName: z.string(),
  updateHash: z.string().nullish(),
});

export const MigrationData = MigrationDataSchema;
export type MigrationData = z.infer<typeof MigrationDataSchema>;

export const MigrationDataFragment = gql`
  fragment MigrationDataFragment on MigrationData {
    migrationName
    updateHash
  }
`;
